import axios from '../utils/axios';

export default function updateCredits(adminId, data) {
    return axios.post('/admin/' + adminId + '/credits/edit', data)
}